import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';
import 'dayjs/locale/de';

// Set dayjs locale globally
dayjs.locale('de');

const CustomDatePicker = ({ 
  value, 
  onChange, 
  label, 
  required = false,
  inputProps = {},
  sx = {},
  ...otherProps 
}) => {
  const handleChange = (newValue) => {
    if (onChange) {
      // Convert dayjs to YYYY-MM-DD format to match native input behavior
      const event = {
        target: {
          value: newValue ? dayjs(newValue).format('YYYY-MM-DD') : ''
        }
      };
      onChange(event);
    }
  };

  return (
    <LocalizationProvider 
      dateAdapter={AdapterDayjs} 
      adapterLocale="de"
      localeText={{
        cancelButtonLabel: 'Abbrechen',
        clearButtonLabel: 'Löschen',
        okButtonLabel: 'OK',
        todayButtonLabel: 'Heute',
      }}
    >
      <DatePicker
        value={value ? dayjs(value) : null}
        onChange={handleChange}
        label={label}
        slotProps={{
          textField: {
            required: required,
            variant: "outlined",
            size: "small",
            InputLabelProps: { shrink: true },
            sx: {
              width: '160px',
              ...sx,
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: 'var(--rd-primary)',
                },
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: 'var(--rd-primary)',
              },
            },
            ...otherProps
          },
          openPickerButton: {
            sx: {
              color: 'var(--rd-primary)',
              '&:hover': {
                backgroundColor: 'color-mix(in srgb, var(--rd-primary) 4%, transparent)',
              },
            }
          },
          actionBar: {
            actions: ['today', 'cancel', 'accept'],
          }
        }}
        sx={{
          '& .MuiPickersDay-root': {
            '&.Mui-selected': {
              backgroundColor: 'var(--rd-primary) !important',
              '&:hover': {
                backgroundColor: 'var(--rd-primary-hover) !important',
              },
            },
          },
          '& .MuiPickersCalendarHeader-switchViewButton': {
            color: 'var(--rd-primary)',
          },
          '& .MuiPickersArrowSwitcher-button': {
            color: 'var(--rd-primary)',
          },
          '& .MuiPickersYear-yearButton.Mui-selected': {
            backgroundColor: 'var(--rd-primary) !important',
          },
          '& .MuiPickersMonth-monthButton.Mui-selected': {
            backgroundColor: 'var(--rd-primary) !important',
          },
          '& .MuiDialogActions-root .MuiButton-root': {
            color: 'var(--rd-primary)',
            '&:hover': {
              backgroundColor: 'color-mix(in srgb, var(--rd-primary) 4%, transparent)',
            },
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default CustomDatePicker;

